import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { selectLogo } from 'core/utils';

// defaultTemplate already applies observer(), so this must not be wrapped again.
const WalmartConnectedTemplate = ({
	t,
	viewStore: { isSuccess, messageKey, channelId, isRedirecting, goToChannel, goToChannelList },
}) => {
	// Handing off to the channel edit page; painting the card first would flash the login chrome.
	if (isRedirecting) {
		return null;
	}

	const logo_show = selectLogo();
	return (
		<main className="body--secondary">
			<section className="w--400--px align--h--center padd--top--med">
				<img className="w--280--px display--b align--h--center" src={logo_show} alt="Logo" />
				<div className="card card--med spc--top--med">
					<h3 className="spc--bottom--sml">
						{t(isSuccess ? 'OAUTH.WALMART.CONNECTED.TITLESUCCESS' : 'OAUTH.WALMART.CONNECTED.TITLEERROR')}
					</h3>
					<p className={isSuccess ? 'spc--bottom--med' : 'type--color--warning spc--bottom--med'}>{t(messageKey)}</p>
					<div className="group">
						{channelId ? (
							<button type="button" className="btn btn--med btn--primary pull" onClick={goToChannel}>
								{t('OAUTH.WALMART.CONNECTED.GOTOCHANNEL')}
							</button>
						) : (
							<button type="button" className="btn btn--med btn--primary pull" onClick={goToChannelList}>
								{t('OAUTH.WALMART.CONNECTED.GOTOCHANNELS')}
							</button>
						)}
					</div>
				</div>
			</section>
		</main>
	);
};

export default defaultTemplate(WalmartConnectedTemplate);
